'use client';

/**
 * Adapter: renders an `UploadFile` (a client-side upload with a `File` handle)
 * through the shared `FileRow`. Callers with server-owned records (no `File`)
 * use `FileRow` directly.
 */

import { formatFileSize, getFileTypeDescriptor } from '@/lib/services/files';
import { FileRow } from './file-row';
import type { UploadFile } from './types';

interface FileDropZoneItemProps {
  file: UploadFile;
  onRemove?: (id: string) => void;
  onRetry?: (id: string) => void;
  /** Read view — hide the remove/cancel affordance. */
  readOnly?: boolean;
}

export function FileDropZoneItem({
  file,
  onRemove,
  onRetry,
  readOnly
}: FileDropZoneItemProps) {
  const descriptor = getFileTypeDescriptor(file.file.type, file.file.name);

  return (
    <FileRow
      label={descriptor.label}
      name={file.file.name}
      // `pending` is the idle display state.
      status={file.status === 'pending' ? 'idle' : file.status}
      sizeLabel={formatFileSize(file.file.size)}
      progress={file.status === 'uploading' ? file.progress : undefined}
      error={file.error}
      onRemove={!readOnly && onRemove ? () => onRemove(file.id) : undefined}
      onRetry={onRetry ? () => onRetry(file.id) : undefined}
    />
  );
}
